export const accountNames = [
	{
		name: 'Acme Inc',
		description: 'Acme Enterprises',
		number: '10011234',
		id: '68098571-8adb-473e-8b7a-93282252aab5',
	},
	{
		name: 'Business Current',
		description: 'Worthington Sk',
		number: '10011101',
		id: '66526105-7d4b-45db-95b1-5c9ce0c10e53',
	},
	{
		name: 'Raptolutions',
		description: 'Raptolutions',
		number: '10013172',
		id: '98b72b75-cb87-4dcd-b44b-f0876f7a8eb8',
	},
	{
		name: 'Paragonetworks',
		description: 'Paragonetworks',
		number: '10014512',
		id: '6911cc2c-b764-4647-83dd-10626e565e24',
	},
	{
		name: 'Ogre Acoustics',
		description: 'Ogre Acoustics',
		number: '10019991',
		id: 'f54dbb86-bcba-49c7-9211-d61e4702c5a6',
	},
	{
		name: 'Turtletainment',
		description: 'Turtletainment',
		number: '10019401',
		id: '552244a2-feca-4cae-8867-f4f244aeca9b',
	},
	{
		name: 'Ridge Foods',
		description: 'Ridge Foods',
		number: '10013888',
		id: '7c99fe13-ae92-4846-bd42-d6c441f82f4a',
	},
	{
		name: 'Jewel Security',
		description: 'Jewel Security',
		number: '10013886',
		id: 'fda0f687-3067-427a-bfcf-14fcb3fa667a',
	},
	{
		name: 'Silver Systems',
		description: 'Silver Systems',
		number: '10011885',
		id: '19e14724-2548-478b-bda3-83ea01d1fb4d',
	},
	{
		name: 'White Wolf Solutions',
		description: 'White Wolf Solutions',
		number: '10012018',
		id: '1b501e6b-9195-4e99-857a-fe4cbc443810',
	},
	{
		name: 'Sunlight Corp',
		description: 'Sunlight Corp',
		number: '10011997',
		id: '39b6faa7-865a-4d17-a4d8-4e7365578018',
	},
	{
		name: 'Apple Acoustics',
		description: 'Apple Acoustics',
		number: '10011977',
		id: '6fbdba5c-53a8-4cf2-a9bc-2bb91ce14253',
	},
	{
		name: 'Pixel Media',
		description: 'Pixel Media',
		number: '10011496',
		id: '07e2a849-3d3f-4fad-b266-d769612b9a79',
	},
	{
		name: 'Essensecurity',
		description: 'Essensecurity',
		number: '10011066',
		id: '0cd31d44-9d5e-4f09-9d9b-b44bd27cde7a',
	},
	{
		name: 'Pyramid Coms',
		description: 'Pyramid Coms',
		number: '10011801',
		id: 'd215a4a1-21ad-45ca-a281-febd00b9d39a',
	},
	{
		name: 'Banshee Foods',
		description: 'Banshee Foods',
		number: '10011777',
		id: '03e3ac4b-4a34-4f7a-b8e3-95d7af2df8f0',
	},
	{
		name: 'Sphinx Limited',
		description: 'Sphinx Limited',
		number: '10012525',
		id: '0718ae45-e084-488a-85b1-00e1402d5f48',
	},
	{
		name: 'Cogent Data',
		description: 'Cogent Data',
		number: '10011666',
		id: '3eb9531c-ced6-420e-8d7d-deaa5f2e910c',
	},
	{
		name: 'Radiant Radish',
		description: 'Radiant Radish',
		number: '10011956',
		id: '822c86c3-ebe5-414c-adf9-93f56e33923f',
	},
	{
		name: 'Reilly Ltd',
		description: 'Reilly Ltd',
		number: '10011901',
		id: '552a3c13-c709-4f12-b4f6-b0dc71bac9d3',
	},
	{
		name: 'Little LLC',
		description: 'Little LLC',
		number: '10011967',
		id: '9237469d-0d02-4c59-89b4-9a655319934a',
	},
	{
		name: 'Heller-Bauch',
		description: 'Heller-Bauch',
		number: '10011918',
		id: '7bad7018-069f-4847-b758-9add3bf5bbb3',
	},
	{
		name: 'Smith And Sons',
		description: 'Smith And Sons',
		number: '10011835',
		id: 'bf41c8b6-0458-404c-a61a-b2502042ceba',
	},
	{
		name: 'Conroy Inc',
		description: 'Conroy Inc',
		number: '10011010',
		id: '7b83b604-c397-415f-a706-1a39c1872bae',
	},
	{
		name: 'Durgan PLC',
		description: 'Durgan PLC',
		number: '10011050',
		id: '15786a14-60fb-4d6b-9ced-aa936fad5643',
	},
	{
		name: 'Cole Ltd',
		description: 'Cole Ltd',
		number: '10011222',
		id: 'e818fdb0-8e14-47b6-b72d-6cb44d06059b',
	},
	{
		name: 'Rempel Inc',
		description: 'Rempel Inc',
		number: '10014111',
		id: 'cff42b2f-773c-4c1b-8fd2-37da47240d04',
	},
	{
		name: 'Wolf and Sons',
		description: 'Wolf and Sons',
		number: '10019124',
		id: '5a3f9927-9072-4033-92b2-3213d77e9512',
	},
	{
		name: 'Wolf and Sons',
		description: 'Wolf and Sons',
		number: '10017821',
		id: '31cec639-7f2b-43bb-b016-ec65e7b54bab',
	},
	{
		name: 'Wiza PLC',
		description: 'Wiza PLC',
		number: '10017852',
		id: '625f8a6d-1c28-4ce6-a0b0-235ba8283560',
	},
	{
		name: 'Roob and Sons',
		description: 'Roob and Sons',
		number: '10011234',
		id: 'ec8da70a-40b4-4209-92e7-0387852df1d5',
	},
	{
		name: 'Connelly Ltd',
		description: 'Connelly Ltd',
		number: '10011942',
		id: 'b86ae6a6-b5ea-41bf-aaeb-56070e399ff3',
	},
	{
		name: 'Kirlin PLC',
		description: 'Kirlin PLC',
		number: '10013015',
		id: '4dd9237a-0d6a-4bd3-9925-ac9460929cd9',
	},
	{
		name: 'Osinki Inc',
		description: 'Osinki Inc',
		number: '10014555',
		id: '8f5caf14-9f4e-45d9-9def-9a5ef2e74d8c',
	},
	{
		name: 'Jacobi Ltd',
		description: 'Jacobi Ltd',
		number: '10014666',
		id: '0e84844a-297a-43bc-9a1c-f65753f0020e',
	},
	{
		name: 'Parker and sons',
		description: 'Parker and sons',
		number: '10012677',
		id: 'bf072cbc-4db9-4715-adc0-1f5bc6c10f07',
	},
	{
		name: 'Doyle Inc',
		description: 'Doyle Inc',
		number: '10012177',
		id: '4899b93e-eefa-4428-aa08-e2a26036aa62',
	},
	{
		name: 'Mante Group',
		description: 'Mante Group',
		number: '10019135',
		id: '654103cd-5ee6-4ff2-a14a-4d994517fc3b',
	},
	{
		name: 'Upton LLC',
		description: 'Upton LLC',
		number: '10018111',
		id: 'dc38f86c-1fb3-411b-aed2-6007b467121e',
	},
	{
		name: 'Nader Inc',
		description: 'Nader Inc',
		number: '10013014',
		id: 'fdff504e-ed1c-47c6-b342-3b4286eeb03b',
	},
	{
		name: 'Lang PLC',
		description: 'Lang PLC',
		number: '10012061',
		id: 'e04a80cb-d100-4a83-ab29-af7681cac9dc',
	},
	{
		name: 'Mills Inc',
		description: 'Mills Inc',
		number: '10011121',
		id: '0fb60961-0b02-494b-b8e4-852f88bd2428',
	},
	{
		name: 'Ritchie Ltd',
		description: 'Ritchie Ltd',
		number: '10010912',
		id: '64b15b3b-daf6-49e9-8012-b0824a67f09d',
	},
	{
		name: 'Reynolds PLC',
		description: 'Reynolds PLC',
		number: '10010102',
		id: '074b36c0-fd31-43e1-9226-244ae35cc97e',
	},
	{
		name: 'Fay Inc',
		description: 'Fay Inc',
		number: '10010301',
		id: 'f2a9e920-530c-4e34-ade3-50092a2ee4df',
	},
	{
		name: 'Dragonsoft',
		description: 'Dragonsoft',
		number: '10010701',
		id: '8133f0c5-8496-45b2-9024-e44f140c1385',
	},
	{
		name: 'Fahey LLC',
		description: 'Fahey LLC',
		number: '10010694',
		id: 'd961d48c-ff68-4f0a-8a40-7779767b8892',
	},
	{
		name: 'Ulrich Inc',
		description: 'Ulrich Inc',
		number: '10010999',
		id: 'b48d7d16-cabf-4383-ab9f-fbc20029d492',
	},
	{
		name: 'Batz Group',
		description: 'Batz Group',
		number: '10010123',
		id: 'c1a39937-d98b-427f-9bc0-d464c5e07339',
	},
	{
		name: 'Rowe Inc',
		description: 'Rowe Inc',
		number: '10010378',
		id: 'e2f65f66-2ab4-4386-a8c4-f8a780242d23',
	},
	{
		name: 'Hoppe PLC',
		description: 'Hoppe PLC',
		number: '10010211',
		id: '820f9edb-48eb-4ed3-95a4-2e0bb6642a4e',
	},
	{
		name: 'Larson and Sons',
		description: 'Larson and Sons',
		number: '10010555',
		id: 'd6800b14-6806-4eca-8b58-a4ce0f2f7eae',
	},
	{
		name: 'Toy-Ratke',
		description: 'Toy-Ratke',
		number: '10010444',
		id: '305c3ee6-93ad-494d-8e55-7939419a8907',
	},
	{
		name: 'Rath-Hyatt',
		description: 'Rath-Hyatt',
		number: '10010150',
		id: 'c21166ea-b9a2-4aee-8e10-f176ac6163a9',
	},
	{
		name: 'Stark and sons',
		description: 'Stark and sons',
		number: '10015001',
		id: '16858641-345a-4112-8099-592d115a5602',
	},
	{
		name: 'Hessel Ltd',
		description: 'Hessel Ltd',
		number: '10016001',
		id: '547426e8-3ab0-4c13-aab2-47705ab5b4f1',
	},
	{
		name: 'Muller PLC',
		description: 'Muller PLC',
		number: '10017001',
		id: 'baca1417-54ac-4e18-a349-932f1e5069e1',
	},
	{
		name: 'Wilderman Inc',
		description: 'Wilderman Inc',
		number: '10018001',
		id: '6b516173-f05a-4a4e-bffd-b94cd2ea530d',
	},
	{
		name: 'Bode PLC',
		description: 'Bode PLC',
		number: '10015665',
		id: 'eb2fa172-4376-42b9-8859-477a6fbbfdda',
	},
	{
		name: 'Pragma Inc',
		description: 'Pragma Inc',
		number: '10015669',
		id: 'fe8b5929-7e1d-4b48-927e-27326334ff96',
	},
	{
		name: 'Armstrong LLC',
		description: 'Armstrong LLC',
		nickName: 'Main acc',
		number: '10014334',
		id: '69c331a8-db8e-43c1-a07e-de85c1759aea',
	},
];

// '822c86c3-ebe5-414c-adf9-93f56e33923f', //Radiant Radish
// '39b6faa7-865a-4d17-a4d8-4e7365578018', //Sunlight Corp

export const favourites = [
	'68098571-8adb-473e-8b7a-93282252aab5', //Acme Inc
];

export const getBusinessCapabilities = () => ({
	'/account/sweeps': false,
	'/account/alerts/transaction/credit': true,
	'/account/payments/bacscredit/approve': true,
	'/case/customer/read': false,
	'/account/propagate/address': false,
	'/account/payments/batch/out': false,
	'/account/payments/transfer/approve': true,
	'/account/mandates/so/write/recurring': false,
	'/users/preferences/write': false,
	'/account/transactions/read': true,
	'/account/books/cheque/reorder': true,
	'/account/alerts/transaction/debit': true,
	'/case/customer/cancel': false,
	'/case/read': false,
	'/account/propagate/home': false,
	'/account/read': true,
	'/account/pools/write': false,
	'/user/write': false,
	'/account/mandates/so/write': true,
	'/account/payments/bacscredit/out': true,
	'/users/read': false,
	'/account/payments/transfer/out': true,
	'/case/cancel': false,
	'/users/device/manage': false,
	'/account/alerts/balance': true,
	'/account/payments/transfer/in': true,
	'/account/projections': false,
	'/account/sweeps/transfer/out': false,
	'/account/payments/uk/ics/in': false,
	'/users/security_device/write': false,
	'/case/customer/managedocs': false,
	'/users/security_device/read': false,
	'/account/payments/alerts': false,
	'/users/card/manage': false,
	'/account/propagate/mobile': false,
	'/account/consent': false,
	'/account/mandates/dd/write': true,
	'/account/payments/list/out': false,
	'/case/reassign': false,
	'/users/preferences/read': false,
	'/account/beneficiaries/import': false,
	'/account/payments/chaps/approve': true,
	'/users/write': false,
	'/account/payments/ift/out': true,
	'/users/permissions/write': false,
	'/account/beneficiaries/read': true,
	'/case/customer/reassign': false,
	'/account/beneficiaries/biller/write': true,
	'/account/beneficiaries/delete': true,
	'/account/payments/read': false,
	'/account/statements/read': true,
	'/account/payments/chaps/out': true,
	'/account/mandates/dd/read': true,
	'/account/payments/templates/readwrite': false,
	'/case/customer/submit': false,
	'/account/transactions/readwrite': false,
	'/case/submit': false,
	'/account/payments/bacsdebit/out': true,
	'/account/payments/ift/approve': true,
	'/user/payments/approve/single': true,
	'/account/payments/uk/default/approve': true,
	'/account/preferences/paperstatementoptout': true,
	'/account/balance/available': true,
	'/account/payments/effectivewarning': true,
	'/account/payments/uk/default/out': true,
	'/account/beneficiaries/account/readwrite': true,
	'/account/statements/order': true,
	'/account/propagate/email': false,
	'/users/strands': false,
	'/account/read/limited': false,
	'/case/write': false,
	'/account/alerts': true,
	'/users/details/write': false,
	'/account/books/payin/reorder': true,
	'/account/securemessage/write': false,
	'/case/customer/write': false,
	'/user/details/mobile/write': false,
	'/user/payments/approve/dual': false,
	'/account/securemessage/read': false,
	'/account/transactions/write': true,
	'/account/pots': false,
	'/account/mandates/so/update': false,
	'/user/details/address/write': false,
	'/user/details/home/write': false,
	'/user/details/email/write': false,
});

export const getRetailCapabilities = () => ({
	'/account/sweeps': false,
	'/account/alerts/transaction/credit': false,
	'/account/payments/bacscredit/approve': false,
	'/case/customer/read': false,
	'/account/propagate/address': false,
	'/account/payments/batch/out': false,
	'/account/payments/transfer/approve': false,
	'/account/mandates/so/write/recurring': false,
	'/users/preferences/write': false,
	'/account/transactions/read': true,
	'/account/books/cheque/reorder': true,
	'/account/alerts/transaction/debit': true,
	'/case/customer/cancel': false,
	'/case/read': false,
	'/account/propagate/home': false,
	'/account/read': true,
	'/account/pools/write': false,
	'/user/write': false,
	'/account/mandates/so/write': true,
	'/account/payments/bacscredit/out': false,
	'/users/read': false,
	'/account/payments/transfer/out': true,
	'/case/cancel': false,
	'/users/device/manage': false,
	'/account/alerts/balance': true,
	'/account/payments/transfer/in': true,
	'/account/projections': true,
	'/account/sweeps/transfer/out': false,
	'/account/payments/uk/ics/in': false,
	'/users/security_device/write': false,
	'/case/customer/managedocs': false,
	'/users/security_device/read': false,
	'/account/payments/alerts': true,
	'/users/card/manage': true,
	'/account/propagate/mobile': false,
	'/account/consent': false,
	'/account/mandates/dd/write': true,
	'/account/payments/list/out': false,
	'/case/reassign': false,
	'/users/preferences/read': false,
	'/account/beneficiaries/import': false,
	'/account/payments/chaps/approve': false,
	'/users/write': false,
	'/account/payments/ift/out': false,
	'/users/permissions/write': false,
	'/account/beneficiaries/read': true,
	'/case/customer/reassign': false,
	'/account/beneficiaries/biller/write': false,
	'/account/beneficiaries/delete': true,
	'/account/payments/read': false,
	'/account/statements/read': true,
	'/account/payments/chaps/out': false,
	'/account/mandates/dd/read': true,
	'/account/payments/templates/readwrite': false,
	'/case/customer/submit': false,
	'/account/transactions/readwrite': false,
	'/case/submit': false,
	'/account/payments/bacsdebit/out': false,
	'/account/payments/ift/approve': false,
	'/user/payments/approve/single': false,
	'/account/payments/uk/default/approve': false,
	'/account/preferences/paperstatementoptout': true,
	'/account/balance/available': false,
	'/account/payments/effectivewarning': true,
	'/account/payments/uk/default/out': true,
	'/account/beneficiaries/account/readwrite': true,
	'/account/statements/order': true,
	'/account/propagate/email': false,
	'/account/mandates/so/read': true,
	'/users/strands': false,
	'/account/read/limited': false,
	'/case/write': false,
	'/account/alerts': true,
	'/users/details/write': false,
	'/account/books/payin/reorder': true,
	'/account/securemessage/write': false,
	'/case/customer/write': false,
	'/user/details/mobile/write': false,
	'/user/payments/approve/dual': false,
	'/account/securemessage/read': false,
	'/account/transactions/write': true,
	'/account/pots': true,
	'/account/mandates/so/update': false,
	'/user/details/address/write': false,
	'/user/details/home/write': false,
	'/user/details/email/write': false,
});
